/**
 * PR53: External Repo Integration Framework — Types
 * All defaults are safe (dryRunOnly, previewOnly, no live execution).
 */
export const EXTERNAL_REPO_SAFE_DEFAULTS = {
    dryRunOnly: true,
    previewOnly: true,
    realIntegrationEnabled: false,
    realExecutionSupported: false,
    realExecutionPerformed: false,
    networkAllowed: false,
    fileMutationAllowed: false,
    commandExecutionAllowed: false,
    browserActionAllowed: false,
    desktopActionAllowed: false,
    productionDbAllowed: false,
    ragVectorMutationAllowed: false,
    requiresOwnerApproval: true,
    requiresExplicitRepoReview: true,
    requiresSecretsConfigured: true,
};
//# sourceMappingURL=externalRepoIntegrationTypes.js.map